import './PROD_MIX.scss';
import ProductBase from 'pages/PROD/ProductBase';

export default class PROD_MIX extends ProductBase {

	onReady () {
		// Initialize Main-Image, Thumbnails, & PhotoSwipe Close-up Gallery
		this.initImageGallery();
		this.removeCloseupBackingElement();
		this.initAltStickyHeader();
		this.initTrayAttributes();
		this.initPurchaseForm();
		this.initTabcordion();
		this.initQNA();
		this.initTooltips();
	}

	async initPurchaseForm () {
		const purchaseFormElement = document.getElementById('js-purchase-form');

		if (!purchaseFormElement) {
			return;
		}

		if (purchaseFormElement.querySelector('.js-add-to-cart')) {
			const {default: AjaxAddToCart} = await import('extensions/ajax-add-to-cart');

			new AjaxAddToCart(purchaseFormElement, {
				scrollToMessage: 'error'
			});
		}

		const {HTMLFormValidator} = await import('extensions/form-validation');

		new HTMLFormValidator({
			fieldContainer: '.g-product-layout-purchase__options-species-item',
			formElement: purchaseFormElement
		});
	}

	initTrayAttributes () {
		this.initSpeciesOptions();
		this.bindTraySizeEvents();
	}

	initSpeciesOptions () {
		for (const speciesSelectElement of document.getElementsByClassName('js-select-species-item')) {
			const optionsCount = speciesSelectElement.options?.length ?? 0;
			let speciesQuantity = parseInt(speciesSelectElement.getAttribute('data-quantity'), 10);

			if (isNaN(speciesQuantity)) {
				speciesQuantity = 0;
			}

			if (!optionsCount || !speciesQuantity) {
				continue;
			}

			const removeSpeciesOptions = [];

			for (let index = 0; index < optionsCount; index++) {
				const speciesOptionElement = speciesSelectElement[index];

				if (!speciesOptionElement.hasAttribute('data-inventory')) {
					continue;
				}

				let speciesOptionInventory = parseInt(speciesOptionElement.getAttribute('data-inventory'), 10);

				if (isNaN(speciesOptionInventory)) {
					speciesOptionInventory = 0;
				}

				if (speciesQuantity > speciesOptionInventory) {
					removeSpeciesOptions.push(speciesOptionElement);
				}
			}

			removeSpeciesOptions.forEach((speciesOption) => {
				speciesSelectElement.removeChild(speciesOption);
			});
		}
	}

	bindTraySizeEvents () {
		const traySizeSelectElement = document.getElementsByClassName('js-select-tray')[0];

		if (!traySizeSelectElement) {
			return;
		}

		this.handleTraySizeChange(traySizeSelectElement);

		traySizeSelectElement.addEventListener('change', this.handleTraySizeChange.bind(this, traySizeSelectElement));
	}

	handleTraySizeChange (traySizeSelectElement) {
		if (!traySizeSelectElement?.value) {
			return;
		}

		const traySize = traySizeSelectElement.value.match(/^TRAY(\d+)/i)[1] ?? false;

		if (traySize === false) {
			return;
		}

		const selectedTraySpeciesElement = document.getElementById(`js-select-species-${traySize}`);

		if (!selectedTraySpeciesElement) {
			return;
		}

		for (const traySpeciesElement of document.getElementsByClassName('g-product-layout-purchase__options-species')) {
			const isSelectedTraySpeciesElement = traySpeciesElement === selectedTraySpeciesElement;

			for (const traySpeciesInputElement of traySpeciesElement.querySelectorAll('input, select')) {
				traySpeciesInputElement.disabled = !isSelectedTraySpeciesElement;
			}

			if (isSelectedTraySpeciesElement) {
				traySpeciesElement.classList.remove('u-hidden');
			} else {
				traySpeciesElement.classList.add('u-hidden');
			}
		}
	}

}
